module.exports = __webpack_public_path__ + "img/info.44cf5bc0.svg";